import React, { useState, useEffect } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import axios from 'axios';
import { Table, Modal, Button, notification } from "antd";
import { baseApiUrl } from "../../../services/api";



function Contact() {
  const [contacts, setContacts] = useState([]);
  const [name, setName] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);


  const [email, setEmail] = useState("");

  const [subject, setSubject] = useState("");

  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [emailError, setEmailError] = useState("");
  const [subjectError, setSubjectError] = useState("");

  const [messageError, setMessageError] = useState("");
  const [nameError, setNameError] = useState("");

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasError = false;

    // Réinitialiser les messages d'erreur
    setErrorMessage('');
    setEmailError('');
    setMessageError('');
    setNameError('');
    setSubjectError('');


    // Validation des champs
    if (!name) {
      setNameError('Veuillez entrer un nom de client.');
      hasError = true;
    }
    if (!email) {
      setEmailError('Veuillez entrer un numéro de téléphone.');
      hasError = true;
    }
    if (!message) {
      setMessageError('Veuillez entrer un CNIB.');
      hasError = true;
    }
    if (!subject) {
      setSubjectError('Veuillez entrer un CNIB.');
      hasError = true;
    }


    // Afficher la notification d'erreur si des champs ne sont pas remplis
    if (hasError) {
      openNotificationWithIcon('error', "Veuillez remplir tous les champs.");
      return;
    }
    const contact = {
      name: name,
      email: email,
      message: message,
      subject: subject,

    };

    try {
      const response = await baseApiUrl.post(
        "/contact", contact);
      console.log("contact ajouté:", response.data);

      // Ajouter le nouveau client en haut de la liste
      setContacts([response.data, ...contacts]);

      // Réinitialiser les champs du formulaire
      setName("");
      setEmail("");
      setMessage("");
      setSubject("");

      setIsModalVisible(false);
      openNotificationWithIcon('success', "votre message a bien éte ajouté avec succès.");
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("Erreur lors de l'envoi des données. Veuillez réessayer.");
      openNotificationWithIcon('error', error.response?.data || "Erreur lors de l'ajout . Veuillez réessayer.");
    }
  };
  return (
    <contact>
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">

                <h1>Contactez-nous</h1>
              </div>
            </div>
          </div>
          {/* <Ecran /> */}
        </div>
      </div>

      <div className="contact-page-sec sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto">
            <div className="contact-page-from">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="single-input">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Votre nom et prenom"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required // Rend le champ obligatoire
                        />
                        {nameError && (
                          <small className="text-danger">{nameError}</small>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="single-input">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Votre adresse mail"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required // Rend le champ obligatoire
                        />
                        {emailError && (
                          <small className="text-danger">{emailError}</small>
                        )}
                      </div>

                    </div>

 <div className="contact-page-from">
 <div className="col-md-12">
                        <div className="single-input">
                          <input

                            type="text"
                            placeholder="Sujet"
                            className="form-control" // Ajout de la classe
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            required // Rend le champ obligatoire
                          />
                          {subjectError && (
                            <small className="text-danger">{subjectError}</small>
                          )}
                        </div>
                      </div>


                    </div>
                    <div className="col-md-12">
                      <div className="single-input">
                        <textarea
                          className="form-control"
                          name="message"
                          placeholder="Votre message"
                          rows="10"
                          id="message-field"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          required
                          style={{ height: "200px" }}
                        >
                          {messageError && (
                            <small className="text-danger">{messageError}</small>
                          )}
                        </textarea>
                      </div>

                      <div className="row" style={{marginTop:"20px"}}>
                      <div className="col-md-12">
                      <div className="button mt-30" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button className="theme-btn1" type="submit">
                          Envoyer
                        </button>
                      </div>
                    </div>

                      </div>
                    </div>
                  </div>
                </form>
              </div>


            </div>
          </div>
        </div>
      </div>

      <Footer1 />

      <Footer />
    </contact>
  );
}

export default Contact;
